import { IFormGroupProps } from '@blueprintjs/core'
import React, { SFC } from 'react'
import StarRatings from 'react-star-ratings'

import { FieldAdapterProps } from './types'

export type Props = FieldAdapterProps<IFormGroupProps>

const StarRatedColor = '#c8102e'
const StarEmptyColor = '#dddddd'
const StarHoverColor = '#c8102e'

const StarRatingAdapter: SFC<Props> = ({ input, disabled }) => {
  // *README*
  // disabled state of StarRatings is controlled by passing
  // changeRating callback fn
  // if no function is passed, star ratings are readonly

  const changeRating = disabled ? null : input.onChange

  return (
    <StarRatings
      rating={input.value}
      changeRating={changeRating}
      starDimension="30"
      starRatedColor={StarRatedColor}
      starEmptyColor={StarEmptyColor}
      starHoverColor={StarHoverColor}
      svgIconPath="M15.8,0.2 C24.1,0.2 30.8,6.6 30.8,14.5 C30.8,17.3 29.9,19.9 28.5,22.1 L21.3,22.1 C23.5,20.4 24.9,17.8 24.9,14.8 C24.9,9.8 20.8,5.7 15.8,5.7 C10.8,5.7 6.7,9.8 6.7,14.8 C6.7,17.8 8.1,20.4 10.3,22.1 L3.1,22.1 C1.6,19.9 0.8,17.3 0.8,14.5 C0.8,6.6 7.5,0.2 15.8,0.2 z M20.6,16.8 L10.8,16.8 C11.5,18.9 13.4,20.4 15.7,20.4 C18,20.4 19.9,18.9 20.6,16.8 z"
      svgIconViewBox="0 0 31 23"
    />
  )
}

export { StarRatingAdapter }



// WEBPACK FOOTER //
// ./src/modules/forms/start-rating-adapter.tsx